import * as React from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { Layout, Menu } from "antd";
import VhIconCommon from "vh-icon-common";

import "antd/lib/layout/style";
import "antd/lib/menu/style";
import "./VhSider.scss";

/**
 * 左侧菜单类型
 *
 * @export
 * @interface VhMenu
 */
export interface VhMenu {
  /**
   * menu id
   *
   * @type {number}
   * @memberof VhMenu
   */
  id?: number;
  /**
   * 菜单code
   *
   * @type {string}
   * @memberof VhMenu
   */
  functionCode: string;
  /**
   * 菜单名称
   *
   * @type {string}
   * @memberof VhMenu
   */
  functionName: string;
  /**
   * 菜单ICON
   *
   * @type {string}
   * @memberof VhMenu
   */
  iconName?: string;
  /**
   * 路由
   *
   * @type {string}
   * @memberof VhMenu
   */
  visitURL?: string;
  /**
   * 分组名称
   *
   * @type {string}
   * @memberof VhMenu
   */
  groupName?: string;
  /**
   * 分组ICON
   *
   * @type {string}
   * @memberof VhMenu
   */
  groupIconName?: string;
  /**
   * 分组用
   *
   * @type {[]}
   * @memberof VhMenu
   */
  children?: VhMenu[]
}

/**
 * 侧边栏props类型接口定义
 *
 * @export
 * @interface VhSiderProps
 */
export interface VhSiderProps {
  title?: string;
  menuList?: VhMenu[]
}

// 侧边栏state类型接口定义
interface SiderState {
  collapsed: boolean;
  current: string;
  openKeys: string[];
  menuList: VhMenu[];
  menuListProps?: VhMenu[];
}

type AllProps = VhSiderProps & RouteComponentProps;

// 类型名称声明
const { Sider } = Layout;

/**
 * 侧边导航组件定义，设置导航
 * 1、可设置展开关闭属性
 *
 * @class VhSider
 * @extends {React.Component}
 */
class VhSider extends React.Component<AllProps, SiderState> {
  static getDerivedStateFromProps(nextProps: AllProps, prevState: SiderState) {
    if (nextProps.menuList !== prevState.menuListProps) {
      const menuListProps = nextProps.menuList;
      const pathname = nextProps.location.pathname;
        const menuList: VhMenu[] = [];
        const tempObj: any = {};

      if (menuListProps) {
        // 根据当前url筛选当前选中menu
        let currentMenu = menuListProps.find((menu: VhMenu) => pathname === menu.visitURL);

        // 没有完全一致的路由，则查看是否子路由
        if (!currentMenu) {
          let len = 0;

          // 设置子路由中最长的那个
          menuListProps.forEach((menu: VhMenu) => {
            if (menu.visitURL && pathname.startsWith(menu.visitURL) && menu.visitURL.length > len) {
              currentMenu = menu;
              len = menu.visitURL.length;
            }
          });
        }

        // 当前选中menu存在的场合
        if (currentMenu) {
          // 设置当前选中menu
          tempObj.current = currentMenu.functionCode;

          // 当前menu存在组的场合
          if (currentMenu.groupName) {
            // 展开组
            tempObj.openKeys = [currentMenu.groupName];
          }
        }

        // 根据组名称设置分组
        menuListProps.forEach((menu: VhMenu) => {
          // 存在组名称，则需分组
          if (menu.groupName) {
            // 没有这个组的场合
            if (!menuList.find((item: VhMenu) => item.functionCode === menu.groupName)) {
              // 设置一个新的组
              menuList.push({
                functionCode: menu.groupName,
                functionName: menu.groupName,
                iconName: menu.groupIconName,
                children: menuListProps.filter((item: VhMenu) => item.groupName === menu.groupName)
              });
            }
          } else {
            // 不存在组名称，则为一级菜单，直接添加
            menuList.push(menu);
          }
        });
      }
      tempObj.menuList = menuList;

      return {
        menuListProps,
        ...tempObj
      };
    }

    return null;
  }

  /**
   * Creates an instance of VhSider.
   * @param {AllProps} props
   * @memberof VhSider
   */
  constructor(props: AllProps) {
    super(props);

    // state设置
    this.state = {
      collapsed: false,
      current: "",
      openKeys: [],
      menuList: []
    };
  }

  /**
   * 初次加载后，设置当前选中menu
   *
   * @memberof VhSider
   */
  public componentDidMount() {
    if (this.props.menuList) {
      const state = this.setMenuList(this.props.menuList, this.props.location.pathname);
      this.setState({...state});
    }

    // 监听路由变化
    this.props.history.listen((location: any) => {
      const state = this.setMenuList(this.props.menuList || [], location.pathname);
      this.setState({...state});
    });
  }

  /**
   * 初始化场合设置当前选中menu
   *
   * @param {AllProps} newProps
   * @memberof VhSider
   */
  // public UNSAFE_componentWillReceiveProps(newProps: AllProps) {
  //   if (this.props.menuList !== newProps.menuList && newProps.menuList) {
  //     this.setMenuList(newProps.menuList);
  //   }
  // }

  // 设置sider关闭展开
  public onCollapse = (collapsed: boolean) =>  {
    this.setState({ collapsed });
  }

  /**
   * 选择组，关闭其他组
   *
   * @memberof VhSider
   */
  public onGroupChange = (openKeys: string[]) => {
    if (this.props.menuList) {
      // 当前所有组的code获取
      const groupKeys: string[] = this.state.menuList.filter((menu: VhMenu) => menu.children && menu.children.length > 0).map((menu: VhMenu) => menu.functionCode);

      // 当前点击组code获取
      const latestOpenKey = openKeys.find((key: string) => this.state.openKeys.indexOf(key) === -1);

      // 点击item不是组的场合
      if (!groupKeys.find((key: string) => key === latestOpenKey)) {
        // 保持当前展开组不变
        this.setState({
          openKeys
        });
      } else {
        // 点击item是组的场合，设置展开组
        this.setState({
          openKeys: latestOpenKey ? [latestOpenKey] : [],
        });
      }
    }
  }

  /**
   * 选中menu的场合
   *
   * @memberof VhSider
   */
  public onMenuChange = (obj: any) => {
    this.setState({
      current: obj.key
    })
  }

  // 渲染
  public render() {
    return (
      <Sider
        collapsible={ true }
        collapsed={ this.state.collapsed }
        onCollapse={ this.onCollapse }
        className="vh-sider"
      >
        {
          !this.state.collapsed ? (
            <div className="vh-sider-title">
              { this.props.title }
            </div>
          ) : null
        }
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={ [this.state.current] }
          openKeys={ this.state.collapsed ? [] : this.state.openKeys }
          onClick={ this.onMenuChange }
          onOpenChange={ this.onGroupChange }>
          {
            this.state.menuList.map((menu: VhMenu) => {
              return menu.children && menu.children.length ?
              (
                <Menu.SubMenu key={ menu.functionCode } title={<span>{ menu.iconName ? <VhIconCommon type={ menu.iconName } /> : null }<span>{ menu.functionName }</span></span>}>
                  {
                    menu.children.map((item: VhMenu) => (
                      <Menu.Item key={ item.functionCode }>
                        <Link to={ item.visitURL || "/" }>
                          {
                            item.iconName ? <VhIconCommon type={ item.iconName } /> : null
                          }
                          <span>{ item.functionName }</span>
                        </Link>
                      </Menu.Item>
                    ))
                  }
                </Menu.SubMenu>
              ) :
              (
                <Menu.Item key={ menu.functionCode }>
                  <Link to={ menu.visitURL || "/" }>
                    {
                      menu.iconName ? <VhIconCommon type={ menu.iconName } /> : null
                    }
                    <span>{ menu.functionName }</span>
                  </Link>
                </Menu.Item>
              )
            })
          }
        </Menu>
      </Sider>
    )
  }

  /**
   * 根据传入menuList进行分组，以及当前选中menu设置
   *
   * @private
   * @memberof VhSider
   * @returns state(menuList, current?, )
   */
  private setMenuList = (menuListProps: VhMenu[], pathname: string) => {
    const menuList: VhMenu[] = [];
    const tempObj: any = {};

    // 根据当前url筛选当前选中menu
    let currentMenu = menuListProps.find((menu: VhMenu) => pathname === menu.visitURL);

    // 没有完全一致的路由，则查看是否子路由
    if (!currentMenu) {
      let len = 0;

      // 设置子路由中最长的那个
      menuListProps.forEach((menu: VhMenu) => {
        if (menu.visitURL && pathname.startsWith(menu.visitURL) && menu.visitURL.length > len) {
          currentMenu = menu;
          len = menu.visitURL.length;
        }
      });
    }

    // 当前选中menu存在的场合
    if (currentMenu) {
      // 设置当前选中menu
      tempObj.current = currentMenu.functionCode;

      // 当前menu存在组的场合
      if (currentMenu.groupName) {
        // 展开组
        tempObj.openKeys = [currentMenu.groupName];
      }
    }

    // 根据组名称设置分组
    menuListProps.forEach((menu: VhMenu) => {
      // 存在组名称，则需分组
      if (menu.groupName) {
        // 没有这个组的场合
        if (!menuList.find((item: VhMenu) => item.functionCode === menu.groupName)) {
          // 设置一个新的组
          menuList.push({
            functionCode: menu.groupName,
            functionName: menu.groupName,
            iconName: menu.groupIconName,
            children: menuListProps.filter((item: VhMenu) => item.groupName === menu.groupName)
          });
        }
      } else {
        // 不存在组名称，则为一级菜单，直接添加
        menuList.push(menu);
      }
    });

    tempObj.menuList = menuList;

    return tempObj;
  }
}

export default withRouter(VhSider);
